import {FC} from "react";

interface Props {
    size?: "small" | "medium" | "large";
}

const sizes = {
    small: "24",
    medium: "40",
    large: "64"
}

const Logo: FC<Props> = ({size = "medium"}) => {
    const sizePixels = sizes[size];
    return (
        <svg width={sizePixels} height={sizePixels} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="10" fill="url(#paint0_linear_8002_1533)"/>
            <path d="M17.289 22.3773L10 15.0883L11.8223 13.266L17.289 18.7328L29.0218 7L30.8441 8.82226L17.289 22.3773Z" fill="#311987"/>
            <path d="M17.289 28.1429L10 20.8539L11.8223 19.0316L17.289 24.4984L29.0218 12.7656L30.8441 14.5879L17.289 28.1429Z" fill="#EBDCFD"/>
            <path d="M17.289 33.9085L10 26.6195L11.8223 24.7973L17.289 30.264L29.0218 18.5312L30.8441 20.3535L17.289 33.9085Z" fill="#EBDCFD"/>
            <defs>
                <linearGradient id="paint0_linear_8002_1533" x1="36.5" y1="38" x2="4.5" y2="1.70916e-06" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#2F5CEF"/>
                    <stop offset="1" stopColor="#9F8FFC"/>
                </linearGradient>
            </defs>
        </svg>
    )
}

export default Logo;